import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { popupsApi } from "../lib/api";
import PopupModal from "./platform/PopupModal";

const dismissKey = (companyId, popupId) => `sgp_company_popup_dismissed_${companyId}_${popupId}`;

/**
 * Global popup announcement shown ONLY to company Admin users, once per
 * browser session, right after they log into their company account.
 * Dispatchers and technicians never see these regardless of active status.
 * Popups are authored in the Platform Console, but the platform admin is
 * the creator, never a recipient — they get a Preview button in the
 * console instead (see PlatformPopups.jsx).
 */
export default function CompanyPopupHost() {
  const { user } = useAuth();
  const location = useLocation();
  const [popup, setPopup] = useState(null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    const path = location.pathname || "";
    const isPublic =
      path.startsWith("/platform") ||
      path.startsWith("/login") ||
      path.startsWith("/register") ||
      path.startsWith("/auth") ||
      path.startsWith("/forgot-password") ||
      path.startsWith("/reset-password") ||
      path.startsWith("/pay/") ||
      path.startsWith("/accept/") ||
      path.startsWith("/f/");
    if (isPublic) return;
    if (!user || user === false) return;
    // The Platform Console admin authors popups — never their own audience.
    if (user.role === "super_admin") return;
    // Popups are only ever shown to company Admin users — dispatchers and
    // technicians should never see them, regardless of active status.
    if (user.role !== "admin") return;

    fetchedRef.current = true;
    popupsApi
      .getActive()
      .then((res) => {
        const p = res?.popup;
        if (p && sessionStorage.getItem(dismissKey(user.companyId, p.id)) !== "1") {
          setPopup(p);
        }
      })
      .catch(() => {});
  }, [user, location.pathname]);

  if (!popup || !user) return null;

  return (
    <PopupModal
      popup={popup}
      onClose={() => {
        sessionStorage.setItem(dismissKey(user.companyId, popup.id), "1");
        setPopup(null);
      }}
    />
  );
}
